export const DEFAULT_COUNTRY = 'BR'

export const DEFAULT_DIAL_CODE = '+55'

export function onlyDigits(value?: string | null): string {
  return (value ?? '').replace(/\D/g, '')
}

export function normalizeDialCode(dialCode?: string | null): string {
  const digits = onlyDigits(dialCode)
  return digits ? `+${digits}` : DEFAULT_DIAL_CODE
}

export function toWhatsAppNumber(nationalDigits: string, dialCode?: string | null): string {
  return `${onlyDigits(normalizeDialCode(dialCode))}${onlyDigits(nationalDigits)}`
}
